/**
 * Portfolio API
 *
 *
*/
import httpService from '@/api/httpService'

const portfolioApi = {
    // Portfolio
    // https://clpapi.tinkeredu.co.kr/static/docs/account.html#resources-member-fetch-portfolio
    portfolioList() {
        return httpService.get('/membership/member/portfolio')
    },
    pointListType(params) {
        return httpService.get('/membership/history/point',params)
    },
    // BookMarked Lesson
    // https://clpapi.tinkeredu.co.kr/static/docs/account.html#resources-member-portfolio-clipping-lesson
    bookMarkedLessonList() {
        return httpService.get('/membership/member/portfolio/clipping/lesson')
    },
    // Liked Lesson
    // https://clpapi.tinkeredu.co.kr/static/docs/account.html#resources-member-portfolio-likes-lesson
    likedLessonList() {
        return httpService.get('/membership/member/portfolio/likes/lesson')
    },
    // Liked Social Lesson
    // https://clpapi.tinkeredu.co.kr/static/docs/account.html#resources-member-likes-article
    likedSocialLessonList(boardId) {
        return httpService.get(`/membership/member/portfolio/SNS/likes`)
    },
     // BookMarked Lesson
    // http://13.230.87.17:8080/static/docs/account.html#_9_5_%EB%B6%81%EB%A7%88%ED%81%AC%ED%95%9C_%EA%B3%BC%EC%A0%9C_bookmark_mission_request_headers
    bookedMarkedMissionList() {
        return httpService.get('/membership/member/portfolio/clipping/mission')
    },
    
   
}

export default portfolioApi